/* Maison & Art de Vivre — theme.js */

(function () {
  'use strict';

  /* ---------------------------------------------------------------- Header */

  function initHeader() {
    var menuToggle = document.querySelector('[data-menu-toggle]');
    var mobileNav = document.querySelector('[data-mobile-nav]');
    var searchToggle = document.querySelector('[data-search-toggle]');
    var searchBar = document.querySelector('[data-search-bar]');

    if (menuToggle && mobileNav) {
      menuToggle.addEventListener('click', function () {
        var isOpen = mobileNav.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    if (searchToggle && searchBar) {
      searchToggle.addEventListener('click', function () {
        var isOpen = searchBar.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          var input = searchBar.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
    }
  }

  /* ------------------------------------------------------------------ Cart */

  function refreshCartCount() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return cart;
      })
      .catch(function () { /* silencieux */ });
  }

  function initQuickAdd() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-quick-add]');
      if (!form) return;

      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      var labelEl = button ? button.querySelector('[data-label]') || button : null;
      var originalLabel = labelEl ? labelEl.textContent : '';
      var addedLabel = form.getAttribute('data-added-label') || 'OK';

      if (button) button.disabled = true;
      if (labelEl) labelEl.textContent = '...';

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(form.querySelector('[name="id"]').value),
            quantity: Number((form.querySelector('[name="quantity"]') || {}).value || 1)
          }]
        })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message);
          return refreshCartCount();
        })
        .then(function () {
          if (labelEl) labelEl.textContent = addedLabel;
          setTimeout(function () {
            if (labelEl) labelEl.textContent = originalLabel;
            if (button) button.disabled = false;
          }, 1800);
        })
        .catch(function () {
          if (labelEl) labelEl.textContent = originalLabel;
          if (button) button.disabled = false;
        });
    });
  }

  /* ---------------------------------------------------------- Cart page qty */

  function initCartQuantity() {
    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-quantity]');
      if (!input) return;
      var form = input.closest('form');
      if (form) form.submit();
    });
  }

  /* ------------------------------------------- Flèches de la galerie produit */

  // Ajoute une flèche gauche et une flèche droite sur la photo principale quand
  // le produit a au moins 2 médias. Chaque clic déclenche la miniature voisine :
  // l'affichage reste géré par la logique existante de la fiche produit.
  function initGalleryArrows() {
    document.querySelectorAll('.cp-media').forEach(function (media) {
      var main = media.querySelector('.cp-main-media');
      var items = media.querySelectorAll('.cp-main-media-item');
      var thumbs = media.querySelectorAll('.cp-thumb');

      if (!main || items.length < 2 || thumbs.length !== items.length) return;
      if (main.querySelector('.cp-arrow')) return;

      function go(step) {
        var current = 0;
        items.forEach(function (item, i) {
          if (item.classList.contains('is-active')) current = i;
        });
        var target = (current + step + items.length) % items.length;
        thumbs[target].click();
      }

      [
        { name: 'prev', step: -1, label: 'Image précédente', path: 'M15 18l-6-6 6-6' },
        { name: 'next', step: 1, label: 'Image suivante', path: 'M9 18l6-6-6-6' }
      ].forEach(function (cfg) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cp-arrow cp-arrow--' + cfg.name;
        btn.setAttribute('aria-label', cfg.label);
        btn.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' +
          cfg.path +
          '"/></svg>';
        btn.addEventListener('click', function () { go(cfg.step); });
        main.appendChild(btn);
      });
    });
  }

  /* ------------------------------------------------------------------ Init */

  function init() {
    initHeader();
    initQuickAdd();
    initCartQuantity();
    initGalleryArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MaisonTheme = { refreshCartCount: refreshCartCount };
})();
